"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroFiltersGroupResults = void 0;
var app_1 = require("app");
var React = require("react");
var search_1 = require("src/search");
var FilterableListTab_1 = require("./FilterableListTab");
var ZeroFiltersGroupResults = function (_a) {
    var selectedFilters = _a.selectedFilters, zeroResultsInformation = _a.zeroResultsInformation;
    var selectedType = React.useMemo(function () { return (0, search_1.getSelectedFilter)(selectedFilters, search_1.FullTextSearchFilters.TypeFilterAlias); }, [selectedFilters]);
    var iconName = FilterableListTab_1.typeIconNameMapping[selectedType];
    return (React.createElement("div", { className: "filterable-list__zero-results container-fluid" },
        React.createElement("div", { className: "filterable-list__zero-results-wrapper" },
            React.createElement("div", { className: "filterable-list__zero-results-message" },
                React.createElement("h2", { className: "filterable-list__zero-results-title" }, zeroResultsInformation.zeroResultsTitle),
                React.createElement("div", { className: "filterable-list__zero-results-text" }, (0, app_1.StringToHTML)(zeroResultsInformation.zeroResultsText))),
            React.createElement("div", { className: "filterable-list__zero-results-image" },
                React.createElement("img", { className: "filterable-list__zero-results-icon ".concat(iconName), src: "/static/images/".concat(iconName, ".svg"), alt: iconName })))));
};
exports.ZeroFiltersGroupResults = ZeroFiltersGroupResults;
